export default __webpack_public_path__ + "static/Sumit_Pal_web_image-d5c95728a0ef89441bf7afc53710a248.png";